import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, mergeProps as _mergeProps, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
    key: 1,
    class: "copy-details-settings__hint px-4 pt-2"
};
import { computed, onMounted, ref, watch } from "vue";
import { settingsService } from "@/services/settingsService";
import { useCopyDetailsFields } from "@/composables/useCopyDetailsFields";
import { useSettingsSaveFlow } from "@/composables/useSettingsSaveFlow";
import { COPY_DETAILS_FIELDS, STANDARD_COPY_DETAILS_FIELDS } from "@/utils/submissionClipboard";
export default /*@__PURE__*/ _defineComponent({
    __name: 'CopyDetailsSettings',
    setup(__props) {
        const { fields, isActiveCompanyConfig, ensureActiveCompanyConfig, applySaved } = useCopyDetailsFields();
        const { saving, error, run } = useSettingsSaveFlow();
        const open = ref(false);
        const draft = ref([]);
        const selected = computed(() => STANDARD_COPY_DETAILS_FIELDS.filter((key) => draft.value.includes(key)));
        const isStandard = computed(() => selected.value.length === STANDARD_COPY_DETAILS_FIELDS.length);
        const changed = computed(() => selected.value.join() !== fields.value.join());
        onMounted(() => {
            ensureActiveCompanyConfig().catch(() => undefined);
        });
        watch(open, (isOpen) => {
            if (!isOpen)
                return;
            draft.value = [...fields.value];
            error.value = "";
        });
        function save() {
            return run(async () => {
                const response = isStandard.value
                    ? await settingsService.resetCopyDetailsFields()
                    : await settingsService.updateCopyDetailsFields(selected.value);
                applySaved(response.fields);
                open.value = false;
            });
        }
        return (_ctx, _cache) => {
            const _component_v_icon = _resolveComponent("v-icon");
            const _component_v_tooltip = _resolveComponent("v-tooltip");
            const _component_v_btn = _resolveComponent("v-btn");
            const _component_v_checkbox_btn = _resolveComponent("v-checkbox-btn");
            const _component_v_list_item_action = _resolveComponent("v-list-item-action");
            const _component_v_list_item = _resolveComponent("v-list-item");
            const _component_v_list = _resolveComponent("v-list");
            const _component_v_alert = _resolveComponent("v-alert");
            const _component_v_spacer = _resolveComponent("v-spacer");
            const _component_v_card_actions = _resolveComponent("v-card-actions");
            const _component_v_card = _resolveComponent("v-card");
            const _component_v_menu = _resolveComponent("v-menu");
            return (_unref(isActiveCompanyConfig))
                ? (_openBlock(), _createBlock(_component_v_menu, {
                    key: 0,
                    modelValue: open.value,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((open).value = $event)),
                    "close-on-content-click": false,
                    location: "bottom start"
                }, {
                    activator: _withCtx(({ props: menuProps }) => [
                        _createVNode(_component_v_btn, _mergeProps(menuProps, {
                            icon: "",
                            variant: "text",
                            size: "small",
                            "aria-label": "Choose Copy Details fields"
                        }), {
                            default: _withCtx(() => [
                                _createVNode(_component_v_icon, { size: "18" }, {
                                    default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                                            _createTextVNode("mdi-cog-outline", -1)
                                        ]))]),
                                    _: 1
                                }),
                                _createVNode(_component_v_tooltip, {
                                    activator: "parent",
                                    location: "top",
                                    disabled: open.value
                                }, {
                                    default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                                            _createTextVNode("Choose copied fields", -1)
                                        ]))]),
                                    _: 1
                                }, 8, ["disabled"])
                            ]),
                            _: 1
                        }, 16)
                    ]),
                    default: _withCtx(() => [
                        _createVNode(_component_v_card, {
                            class: "copy-details-settings",
                            "min-width": "280",
                            rounded: "lg"
                        }, {
                            default: _withCtx(() => [
                                _cache[7] || (_cache[7] = _createElementVNode("div", { class: "copy-details-settings__header" }, [
                                    _createElementVNode("div", { class: "copy-details-settings__title" }, "Copy Details fields"),
                                    _createElementVNode("div", { class: "copy-details-settings__hint" }, "Applies to everyone at your company.")
                                ], -1)),
                                _createVNode(_component_v_list, {
                                    selected: draft.value,
                                    "onUpdate:selected": _cache[0] || (_cache[0] = ($event) => ((draft).value = $event)),
                                    selectable: "",
                                    "select-strategy": "leaf",
                                    density: "compact",
                                    class: "py-0"
                                }, {
                                    default: _withCtx(() => [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(COPY_DETAILS_FIELDS), (field) => {
                                            return (_openBlock(), _createBlock(_component_v_list_item, {
                                                key: field.key,
                                                value: field.key,
                                                title: field.label,
                                                active: false
                                            }, {
                                                prepend: _withCtx(({ isSelected }) => [
                                                    _createVNode(_component_v_list_item_action, { start: "" }, {
                                                        default: _withCtx(() => [
                                                            _createVNode(_component_v_checkbox_btn, {
                                                                "model-value": isSelected,
                                                                "aria-label": field.label,
                                                                color: "primary",
                                                                density: "compact"
                                                            }, null, 8, ["model-value", "aria-label"])
                                                        ]),
                                                        _: 2
                                                    }, 1024)
                                                ]),
                                                _: 2
                                            }, 1032, ["value", "title"]));
                                        }), 128))
                                    ]),
                                    _: 1
                                }, 8, ["selected"]),
                                (_unref(error))
                                    ? (_openBlock(), _createBlock(_component_v_alert, {
                                        key: 0,
                                        type: "error",
                                        variant: "tonal",
                                        density: "compact",
                                        class: "mx-4 mt-2"
                                    }, {
                                        default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_unref(error)), 1)
                                        ]),
                                        _: 1
                                    }))
                                    : (!selected.value.length)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_1, "Keep at least one field."))
                                        : _createCommentVNode("", true),
                                _createVNode(_component_v_card_actions, { class: "px-4 pb-3" }, {
                                    default: _withCtx(() => [
                                        _createVNode(_component_v_btn, {
                                            variant: "text",
                                            size: "small",
                                            disabled: isStandard.value || _unref(saving),
                                            onClick: _cache[1] || (_cache[1] = ($event) => (draft.value = [..._unref(STANDARD_COPY_DETAILS_FIELDS)]))
                                        }, {
                                            default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                                                    _createTextVNode(" Reset to standard ", -1)
                                                ]))]),
                                            _: 1
                                        }, 8, ["disabled"]),
                                        _createVNode(_component_v_spacer),
                                        _createVNode(_component_v_btn, {
                                            color: "primary",
                                            variant: "flat",
                                            size: "small",
                                            disabled: !selected.value.length || !changed.value,
                                            loading: _unref(saving),
                                            onClick: save
                                        }, {
                                            default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                                                    _createTextVNode(" Save ", -1)
                                                ]))]),
                                            _: 1
                                        }, 8, ["disabled", "loading"])
                                    ]),
                                    _: 1
                                })
                            ]),
                            _: 1
                        })
                    ]),
                    _: 1
                }, 8, ["modelValue"]))
                : _createCommentVNode("", true);
        };
    }
});
